import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../Button/Button';

export interface ErrorStateProps {
  title?: string;
  description?: string;
  retryLabel?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Something went wrong',
  description = 'We could not load this content. Please try again.',
  retryLabel = 'Try again',
  onRetry,
  className = '',
}) => (
  <div className={`ds-state ${className}`} role="alert">
    <div className="ds-state__icon">
      <AlertCircle size={24} color="var(--ds-error)" />
    </div>
    <h3 className="ds-state__title">{title}</h3>
    <p className="ds-state__desc">{description}</p>
    {onRetry ? (
      <Button variant="secondary" onClick={onRetry}>
        {retryLabel}
      </Button>
    ) : null}
  </div>
);

export default ErrorState;
